export default __webpack_public_path__ + "static/media/pincel.c7245bdd.png";